import React from "react";
import styles from "./Card.module.scss";
import { cn } from "@/shared/lib/utils";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "narrow" | "flush";
}

export function Card({ children, className, variant = "default" }: CardProps) {
  return (
    <div
      className={cn(
        styles.card,
        {
          [styles.narrow]: variant === "narrow",
          [styles.flush]: variant === "flush",
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
